import React, { FC } from "react";

import { Lighting } from "@ovou-inc/ovou-ui";

import { Button } from "../Button";
import { Flex } from "../Container";
import { Text } from "../Typography";
import { useUpgradeModal } from "hooks/useUpgradeModal";
import { useTracking } from "hooks";

export const UpgradeButton: FC<{
  feature: string;
  /** Optional handler that opens a specific upsell instead of the default
   *  UpgradeModal (which is a no-op for active owners/admins). */
  onClick?: () => void;
}> = ({ feature, onClick }) => {
  const track = useTracking();
  const { openModal } = useUpgradeModal();

  const handleClick = () => {
    track?.({ upgrade: true, customTrackingProps: { source: feature } });
    if (onClick) {
      onClick();
      return;
    }
    openModal?.();
  };

  return (
    <Button
      size="sm"
      padding="0 5px 0 10px"
      height="32px"
      variant="outline"
      _focus={{ outline: "none" }}
      onClick={handleClick}
    >
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight="600" marginRight="5px">
          Upgrade
        </Text>
        <Lighting />
      </Flex>
    </Button>
  );
};
